import { Routes, Route } from "react-router-dom";
import FinalPage from "./Components/Landing Page/FinalPage";
import Video from "./Components/Landing Page/Video";
import Header from "./Components/Landing Page/Header";
import Mindset from "./Components/Landing Page/Mindset";
import MainRoom from "./Components/Sessions/MainRoom";
// import Quotes from './Components/Landing Page/Quotes'
import Footer from "./Components/Landing Page/Footer";
import Dashboard from "./Components/Dashboard/Dashboard";
import Auth from "./Components/Authentication/Auth";
import Third from "./Components/Landing Page/Third/Third";
const App = () => {
  return (
    <Routes>
      <Route exact path="/" element={<FinalPage />}></Route>

      <Route exact path="/auth" element={<Auth />}></Route>
      <Route exact path="/video" element={<Video />}></Route>
      <Route exact path="/final" element={<FinalPage />}></Route>
      <Route exact path="/mindset" element={<Mindset />}></Route>
      <Route exact path="/third" element={<Third />}></Route>


      <Route exact path="/dashboard" element={<Dashboard />}></Route>
      <Route exact path="/footer" element={<Footer />}></Route>
      <Route exact path="/mainRoom" element={<MainRoom />}></Route>
    </Routes>
  );
};

export default App;
